import { combineReducers } from "react-reducer-store"

import appReducer from "../../modules/app/reducer"
import customerSearchReducer from "../../modules/customer/components/reducer"

const rootReducer = combineReducers({
  app: appReducer,
  customerSearch:customerSearchReducer
})

export default rootReducer
